import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Utils from "../../configs/Utils";
import MailTemplateBlock from "../../Components/MailTemplates";
import PageHeader from "../../Components/Common/PageHeader";

const MailTemplatesPage = () => {
  const { workspaceId } = useParams();

  useEffect(() => {
    Utils.setPageTitle("Mail Templates");
  }, []);

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader 
          title="Mail Templates" 
          description="Manage email templates for this workspace" 
          icon={faEnvelope} 
        />

        <MailTemplateBlock workspaceId={workspaceId} />
      </div>
    </main>
  );
};

export default MailTemplatesPage;
